import { render, staticRenderFns } from "./MusicPreview.vue?vue&type=template&id=70b9f834"
import script from "./MusicPreview.vue?vue&type=script&lang=js"
export * from "./MusicPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports